export default __webpack_public_path__ + "static/media/fridge2-afterA-1440w.817333cf.webp";